export const SUPPORT_EMAIL_STOREROUTER = "support@storerouter.ai";
export const SUPPORT_EMAIL_COSIMO = "support@cosimo.shop";
/** Terms of Service and legal inquiries */
export const LEGAL_EMAIL_COSIMO = "legal@storerouter.ai";
